import { ErrorHelper } from '../helpers';

export class HttpError {
  statusCode: number;
  codes: string [];

  constructor(statusCode: number, codes: string[]) {
    this.statusCode = statusCode;
    this.codes = codes;
  }

  get message(): string {
    return this.codes.map((code) => ErrorHelper.getHttpErrorMessage(code)).join('|');
  }
}
